import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSysadminStore } from '../../stores';

const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/orders': 'Orders',
  '/patients': 'Patients',
  '/users': 'Users',
  '/medications': 'Medications',
  '/email-templates': 'Email Templates',
  '/settings': 'Settings',
  '/admin/users-roles': 'Users & Roles',
  '/admin/email-templates': 'Email Templates',
  '/admin/questionnaires': 'Questionnaires',
  '/admin/medications': 'Medications',
};

export const AppLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { selectedCompanyId } = useSysadminStore();

  const pageTitle = pageTitles[location.pathname] || '';

  return (
    <div className="flex h-screen bg-secondary-50 dark:bg-secondary-900 transition-colors duration-200">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} title={pageTitle} />

        <main className="flex-1 overflow-y-auto scrollbar-thin bg-secondary-50 dark:bg-secondary-900">
          <div className="container mx-auto px-4 lg:px-6 py-6">
            <Outlet key={selectedCompanyId ?? 'system'} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;



